import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {changeTitle} from 'modules/ui';
import {injectIntl} from 'react-intl';

import { resetRequest, initResetPassword, cleanErrors } from 'modules/auth';

import ResetPasswordForm from 'components/login/ResetPasswordForm';

/** Redux container for the reset password form container*/
class ResetPasswordFormContainer extends Component {

    static propTypes = {
        auth: PropTypes.object //The auth object
    };

    state = {
        resetSuccess: false // If the reset was succesfuly
    };

    /**
     * Initializes the reset password and the default states of the reset.
     */
    componentWillMount() {
        const {dispatch, intl: {formatMessage}} = this.props;

        dispatch(changeTitle(formatMessage({id: 'title.recover_password'})));
        dispatch(initResetPassword());

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        dispatch(cleanErrors());
    }

    /**
     * Sends the email to the endpoint.
     * @param {string} email the email that will be sent in the form.
     */
    handleSubmit(email) {
        const { dispatch } = this.props;

        dispatch(resetRequest(email))
            .then(() => {
                this.setState({
                    resetSuccess: true
                });
            });
    }

    render() {
        const { auth:{isResetting, resetError}} = this.props;
        const {resetSuccess} = this.state;

        const resetErrorMessage = typeof resetError === 'string' ? resetError : resetError && resetError.message;


        return (
            <ResetPasswordForm
                onSubmit={this.handleSubmit}
                isResetting={isResetting}
                resetError={resetErrorMessage}
                resetSuccess={resetSuccess}
            />
        );
    }
}

const mapStateToProps = state => ({
    auth:    state.auth,
    routing: state.routing
});

export default injectIntl(connect(mapStateToProps)(ResetPasswordFormContainer));



// WEBPACK FOOTER //
// ./src/containers/reset/ResetPasswordFormContainer.jsx